import moment from 'moment'

export function convertDateStandard(date: string) {
  if (date) {
    return moment(date).format("YYYY-MM-DD")
  }

  return "-"
}